var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"containerElement",style:(_vm.style),attrs:{"className":"vue-monaco-editor-container"}})}
var staticRenderFns = []

export { render, staticRenderFns }